<div class="container">
  <div class="header-section">
    <div class="left">
      <app-page-close-button (click)="goBack()"></app-page-close-button>

      <div class="title"> @if (readOnlyMode) { View } @else if(masterEditingEnabled) { Edit } @else
        {Add New} Vessel</div>
    </div>
      
    <div class="right header_actions">
      <ng-container *ngIf="readOnlyMode">
        <button type="button" class="secondary_button" (click)="goBack()">
          Back
        </button>
      </ng-container>
      <ng-container *ngIf="!readOnlyMode">
        <button type="button" class="secondary_button" (click)="goBack()">
          Cancel
        </button>
        <button
          type="button"
          class="primary_button"
          (click)="submitMasterForm()"
        >
          @if(masterEditingEnabled){ Update }@else { Save }
        </button>
      </ng-container>
    </div>
  </div>

  <div class="container-content card-layout">
    <app-dynamic-form
        [formGroup]="masterForm"
        [formConfig]="vesselDynamicformConfig"
        >
        </app-dynamic-form>
  </div>
</div>
